module.exports = __webpack_public_path__ + "static/media/tg.b1fa57c1.svg";